'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var desktop = require('@alfalab/core-components/button/desktop');
var text = require('@alfalab/core-components/typography/text');
var bemReactClassname = require('bem-react-classname');
var cn = require('../../cn.js');
var lib_formatters = require('../../lib/formatters.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var TIME_FORMAT = {
    SECONDS: 'seconds',
    MINUTES: 'minutes',
};
var TIMER_ITERATION_VALUE = 1000;
var SmsCountdown = /** @class */ (function (_super) {
    tslib.__extends(SmsCountdown, _super);
    function SmsCountdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('sms-countdown');
        _this.state = {
            timer: _this.props.duration,
            isRepeatedSmsButtonShow: false,
            isCountdownShow: true,
        };
        _this.handleRepeatSmsButtonClick = function (event) {
            var onRepeatSms = _this.props.onRepeatSms;
            if (_this.timerID) {
                _this.setState({ isRepeatedSmsButtonShow: false });
                return;
            }
            _this.startSmsCountdown();
            if (onRepeatSms) {
                onRepeatSms(event);
            }
        };
        return _this;
    }
    SmsCountdown.prototype.componentDidMount = function () {
        this.startSmsCountdown();
        this.initialized = true;
    };
    SmsCountdown.prototype.componentDidUpdate = function (prevProps) {
        var isRepeatedSmsButtonShow = this.state.isRepeatedSmsButtonShow;
        if (isRepeatedSmsButtonShow) {
            return;
        }
        var disabled = this.props.disabled;
        if (disabled && disabled !== prevProps.disabled && !this.timerID) {
            // если компонент переключился в активное состояние, а таймер еще не запушен, то старуем его
            this.startTimer();
        }
    };
    SmsCountdown.prototype.componentWillUnmount = function () {
        this.stopTimer();
    };
    SmsCountdown.prototype.render = function () {
        var _a = this.props, id = _a.id, testId = _a["data-test-id"];
        var isRepeatedSmsButtonShow = this.state.isRepeatedSmsButtonShow;
        return (React__default.default.createElement("div", { className: this.cn(), id: id, "data-test-id": testId }, isRepeatedSmsButtonShow
            ? this.renderRepeatedSmsButton()
            : this.renderRepeatedSmsText()));
    };
    /**
     * Запускает таймер обратного отсчёта
     */
    SmsCountdown.prototype.startSmsCountdown = function () {
        var initiallyDisplayCountdown = this.props.initiallyDisplayCountdown;
        this.setState({
            timer: this.props.duration,
            isRepeatedSmsButtonShow: false,
            isCountdownShow: this.initialized || initiallyDisplayCountdown,
        });
        this.startTimer();
    };
    SmsCountdown.prototype.renderRepeatedSmsButton = function () {
        var _a = this.props, disabled = _a.disabled, buttonText = _a.buttonText, message = _a.message, theme = _a.theme;
        return (React__default.default.createElement("div", null,
            React__default.default.createElement(desktop.ButtonDesktop, { className: this.cn('button'), size: "xxs", view: "tertiary", onClick: this.handleRepeatSmsButtonClick, colors: theme === 'alfa-on-color' ? 'inverted' : 'default', disabled: disabled }, buttonText || message)));
    };
    SmsCountdown.prototype.renderRepeatedSmsText = function () {
        var _a = this.props, retryText = _a.retryText, message = _a.message, phone = _a.phone, hasPhoneMask = _a.hasPhoneMask;
        var isCountdownShow = this.state.isCountdownShow;
        return (React__default.default.createElement("div", null,
            React__default.default.createElement(text.Text, { view: "secondary-large", className: this.cn('text') },
                phone && (React__default.default.createElement("div", null,
                    "\u041A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430",
                    ' ',
                    hasPhoneMask ? lib_formatters.formatMaskedPhone(phone) : phone)),
                isCountdownShow && "".concat(retryText || message, " \u0447\u0435\u0440\u0435\u0437 ").concat(this.formattedTimeLeft))));
    };
    SmsCountdown.prototype.startTimer = function () {
        var _this = this;
        this.stopTimer();
        var start = Date.now();
        var time = 0;
        var tic = function () {
            time += TIMER_ITERATION_VALUE;
            var diff = (new Date().getTime() - start) - time;
            var timer = _this.state.timer;
            var onCountdownFinished = _this.props.onCountdownFinished;
            if (timer <= 0) {
                _this.stopTimer();
                _this.setState({
                    timer: 0,
                    isRepeatedSmsButtonShow: true,
                    isCountdownShow: true,
                });
                if (onCountdownFinished) {
                    onCountdownFinished();
                }
            }
            else {
                _this.setState(function (prevState) { return ({
                    timer: prevState.timer - TIMER_ITERATION_VALUE,
                }); });
                _this.timerID = setTimeout(tic, (TIMER_ITERATION_VALUE - diff));
            }
        };
        this.timerID = setTimeout(tic, TIMER_ITERATION_VALUE);
    };
    SmsCountdown.prototype.stopTimer = function () {
        if (this.timerID) {
            clearTimeout(this.timerID);
            this.timerID = null;
        }
    };
    Object.defineProperty(SmsCountdown.prototype, "formattedTimeLeft", {
        get: function () {
            var timer = this.state.timer;
            var format = this.props.format;
            return format === TIME_FORMAT.MINUTES
                ? lib_formatters.formatMsAsMinutes(timer)
                : "".concat(timer / TIMER_ITERATION_VALUE, " \u0441\u0435\u043A");
        },
        enumerable: false,
        configurable: true
    });
    SmsCountdown.defaultProps = {
        duration: 5000,
        disabled: false,
        phone: null,
        hasPhoneMask: true,
        message: 'Запросить пароль повторно',
        onRepeatSms: null,
        format: TIME_FORMAT.SECONDS,
        initiallyDisplayCountdown: true,
    };
    return SmsCountdown;
}(React.PureComponent));
/**
 * Компонент обратного отсчета для SMS подтверждения.
 * @visibleName SmsCountdown
 */
// TODO typescript error
// eslint-disable-next-line
// @ts-ignore
var SmsCountdown$1 = cn.withTheme(SmsCountdown);

exports.SmsCountdown = SmsCountdown;
exports.TIME_FORMAT = TIME_FORMAT;
exports.default = SmsCountdown$1;
